import * as ActionType from './contant'
import ls from 'utils/secureLocalStorage'

const STORAGE = 'state_auth'
const initState = {}

const initializeState = () => {
    const auth = ls.get(STORAGE)
    const state = auth ? JSON.parse(auth) : initState
    return state
}

const reducer = (state = initializeState(), action) => {
    const { type, value } = action

    switch (type) {
        case 'VALIDATING_TOKEN':
            return {
                ...state,
                validatingToken: value
            }
        case ActionType.AUTH_SET:
            ls.set(STORAGE, JSON.stringify(value))
            return { ...value }
        case ActionType.AUTH_SET_TOKEN:
            const dataAuth =
            {
                ...state,
                ...value,
            }

            ls.set(STORAGE, JSON.stringify(dataAuth))
            // console.log('-->', auth.attributes)
            return { ...dataAuth, validatingToken: false }
        case ActionType.AUTH_CLEAR:
            ls.clear(STORAGE)
            return {}
        default:
            return state
    }
}

export default reducer
